import { post } from '@/util/http'
// 新增待审批角色信息
export const insertRoleAprv = params => post(`/sysrole/create.json`, params)
export const updateRole = params => post(`/sysrole/update.json`, params)
export const deleteRole = params => post(`/sysrole/delete.json`, params)
// 更新待审批角色信息
// export const updateRole = params => post(`/sum/sumRoleAprv/update`, params)
// 删除待审批角色信息
// export const deleteRole = params => post(`/sum/sumRoleAprv/delete`, params)
// 分页获取角色信息
export const getRoles = params => post(`/sysrole/find`, params)
// 获取应用对应的菜单信息
export const getMenus = params => post(`/sum/sumRole/selectMenu`, params)

/**
 * 分页模糊查询
 *
 * @param fuzzyText
 *            模糊查询字符串
 * @param current
 *            指定页号
 * @param size
 *            每页条数
 * @return Result
 */
export const selectPageByFuzzy = params => post(`/sum/sumRole/selectPageByFuzzy`, params)
